import { Button } from '@chakra-ui/react';
import { AddIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { BlockNoteView } from '@blocknote/mantine';
import {
  DefaultReactSuggestionItem,
  GridSuggestionMenuController,
  SuggestionMenuController,
} from '@blocknote/react';
import { BlockNoteEditor, BlockSchema, filterSuggestionItems } from '@blocknote/core';
import React, { ReactElement } from 'react';

type Props<T extends BlockSchema> = {
  editor: BlockNoteEditor<T>;
  getSlashMenuItems: (editor: BlockNoteEditor<T>) => DefaultReactSuggestionItem[];
  onEditorChange: () => void;
  shouldShowEditor: boolean;
  onShowEditor: () => void;
};

export const WorksheetEditor = <T extends BlockSchema>({
  editor,
  getSlashMenuItems,
  onEditorChange,
  shouldShowEditor,
  onShowEditor,
}: Props<T>): ReactElement => {
  return (
    <>
      {/* Editor */}
      {!shouldShowEditor ? (
        <Button variant="secondary" onClick={onShowEditor} my="20px">
          <NovaIcon icon={AddIcon} size="s" aria-hidden />
          Arbeitsblatt beginnen
        </Button>
      ) : (
        <BlockNoteView
          slashMenu={false}
          editor={editor}
          onChange={onEditorChange}
          data-theming-css-variables
          emojiPicker={false}
        >
          <GridSuggestionMenuController triggerCharacter=":" columns={10} minQueryLength={2} />
          <SuggestionMenuController
            triggerCharacter="/"
            getItems={async (query) => filterSuggestionItems(getSlashMenuItems(editor), query)}
          />
          <Button
            variant="secondaryOutline"
            borderColor="border.accent"
            borderStyle="dashed"
            width="100%"
            textStyle="body.s.medium"
            color="text.secondary"
            mt="30px"
            onClick={() => {
              editor.setTextCursorPosition(editor.document[editor.document.length - 1], 'end');
              if (editor.document[editor.document.length - 1].type !== 'paragraph') {
                const enterEvent = new KeyboardEvent('keydown', {
                  key: 'Enter',
                  code: 'Enter',
                  keyCode: 13,
                  which: 13,
                  bubbles: true,
                  cancelable: true,
                  composed: true,
                });
                editor.domElement?.dispatchEvent(enterEvent);
              }
              editor.openSuggestionMenu('/');
            }}
          >
            <NovaIcon icon={AddIcon} size="s" color="text.secondary" aria-hidden />
            Block hinzufügen
          </Button>
        </BlockNoteView>
      )}
    </>
  );
};
